module.exports = __webpack_public_path__ + "static/KC10-44aed10ee52970911a24ea509ca7e03b.png";